import _ from 'lodash';

import {BOOKING_TYPE_TO_PURPOSE_TYPE_MAPPER} from 'ducks/bookings';

export const checkForNotMatchingRoomPurposesToBookingType = ({
  roomPurposesForPeriod,
  bookingType
}) =>
  roomPurposesForPeriod.filter(
    roomPurpose =>
      roomPurpose.purpose !== BOOKING_TYPE_TO_PURPOSE_TYPE_MAPPER[bookingType]
  ).length > 0;
